import React, { useState, useEffect } from "react";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import SideBar from "../components/Home/SideBar.js";
import Chat from "../components/Home/Chat.js";
import { useSelector, useDispatch } from "react-redux";

export default function Home({ updateUser }) {
  const { toggle, userId } = useSelector(state => ({
    ...state.Toggle,
    ...state.User
  }));
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch({
      type: "CREATE_SOCKET",
      payload: {
        userId
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="Home">
      <SideBar isOpenSideBar={toggle} updateUser={updateUser} />
      <Chat />
    </div>
  );
}
